
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13023',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13023",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.489",
  "data-fetching-client": "static-1.9869",
  "foundations-components": "static-1.8325",
  "foundations-components-legacy": "static-1.1350",
  "foundations-theming": "static-1.4659",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.85",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8237",
  "hub-http-shared-msw-handlers": "static-1.10466",
  "hubspot-dlb": "static-2.1877",
  "hubspot-url-utils": "static-1.4282",
  "HubStyleTokens": "static-2.11686",
  "I18n": "static-7.1651",
  "jasmine-runner": "static-1.6665",
  "marketplace-discovery-studio-lib": "static-1.481",
  "marketplace-storefront-base": "static-1.13086",
  "quartz": "static-1.7314",
  "react-dlb": "static-1.84",
  "react-rhumb": "static-1.16915",
  "reactive-variable-buffer-atom": "static-1.3067",
  "reporting-testing-lib": "static-1.10360",
  "reselect": "static-3.8",
  "settings-ui-lib": "static-1.12731",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7504",
  "ui-addon-i18n": "static-1.11357",
  "ui-addon-react-router-dom": "static-1.9746",
  "unified-auth": "static-1.746",
  "unified-auth-core-lib": "static-1.1028",
  "usage-tracker": "static-1.7566",
  "usage-tracker-core": "static-1.7416",
  "customer-data-property-utils": "static-1.8307",
  "hub-http": "static-1.6429",
  "integrations-lib": "static-1.16817",
  "marketplace-ui-common": "static-1.20459",
  "marketplace-ui-install": "static-1.445",
  "property-management-iframe": "static-1.13861",
  "quartz-config": "static-1.1092",
  "quartz-core": "static-1.6533",
  "quartz-routing": "static-1.744",
  "quick-fetch": "static-1.4064",
  "react": "static-7.190",
  "rpc-client-utils": "static-1.4872",
  "ts-schema": "static-1.4227",
  "ui-universal-auth": "static-1.9232",
  "UIComponents": "static-3.8632",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9849",
  "react-redux": "static-7.75",
  "redux": "static-4.16",
  "styled-components": "static-2.94",
  "bend-plugin-trellis-migration": "static-1.3547",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3591",
  "quartz-webpack": "static-1.3538",
  "bend-plugin-quartz-routing": "static-1.392",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4594",
  "floating-ui": "static-1.60",
  "foundations-assets": "static-1.5086",
  "foundations-theming-specialty": "static-1.2375",
  "framer-motion": "static-1.75",
  "hs-story-utils": "static-1.9637",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.51",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5487",
  "react-virtualized": "static-2.102",
  "StyleGuideUI": "static-3.491",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2365",
  "ui-fonts": "static-1.948",
  "ui-images": "static-2.1215",
  "bend-plugin-foundations-theming": "static-1.3142",
  "foundations-theming-base": "static-1.3644",
  "stylex": "static-1.37",
  "HeadJS": "static-2.782",
  "hs-test-utils-bend-plugin": "static-1.3348",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4534",
  "ui-addon-video-player": "static-1.8918",
  "ai-components-ui-library": "static-1.9501",
  "ai-rendering-library": "static-1.10925",
  "chirp-fetch": "static-1.2099",
  "connections-embed-lib": "static-1.1368",
  "copilot-toolkit": "static-1.11675",
  "feedback-loader": "static-1.29679",
  "laboratory-lib": "static-3.7363",
  "marketplace-embed": "static-1.22730",
  "marketplace-ui-details": "static-1.10354",
  "marketplace-ui-reviews": "static-1.20414",
  "marketplace-ui-tracking": "static-1.14629",
  "sanitize-text": "static-1.8360",
  "usage-tracker-multi": "static-1.5980",
  "usage-tracker-session-replay": "static-1.5252",
  "wootric-nps": "static-1.7130",
  "quartz-head": "static-1.979",
  "web-vitals": "static-1.9",
  "apollo-link-hub-http": "static-2.4868",
  "immer": "static-1.33",
  "immerable": "static-1.4361",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2635",
  "reporting-data": "static-1.68427",
  "cssUtils": "static-1.855",
  "flux-actions": "static-1.355",
  "HubStyle": "static-2.11993",
  "PatternValidationJS": "static-1.3109",
  "react-colorpicker": "static-2.10421",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10578",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7556",
  "icons": "static-2.668",
  "marketplace-ui-apps-core": "static-1.18991",
  "storybook-react": "static-1.36",
  "trellis-story-utils": "static-1.4719",
  "foundations-components-test-utils": "static-1.5808",
  "quartz-i18n": "static-1.989",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.277",
  "ads-unified-auth-lib": "static-1.812",
  "google-sheets-integration-lib": "static-1.853",
  "microsoft-drive-integration-lib": "static-1.976",
  "surveymonkey-integration-lib": "static-1.296",
  "slack-ui-library": "static-1.10611",
  "fsm": "static-1.3945",
  "customer-data-objects": "static-1.7893",
  "property-translator": "static-1.5607",
  "hs-locale-management": "static-1.227",
  "frontend-preferences-client": "static-1.8139",
  "hs-promise-utils": "static-1.5805",
  "hubspot-apollo-client": "static-1.5089",
  "integrations-error-boundary-lib": "static-1.14232",
  "integrations-tracking-lib": "static-1.5819",
  "native-integrations-shared-strings": "static-1.7988",
  "sanitize": "static-1.4689",
  "superstore": "static-1.4968",
  "ui-shepherd-react": "static-3.10473",
  "ai-settings-ui-library": "static-1.8203",
  "hub-http-janus": "static-1.859",
  "hubspotter-http": "static-1.4798",
  "immutable-less": "static-1.4863",
  "marketplace-ui-client-types": "static-1.17866",
  "nav-meta": "static-1.30271",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18272",
  "ui-product-approvals-common": "static-1.818",
  "ai-studio-lib": "static-1.12260",
  "hubspot-prosemirror": "static-1.18832",
  "integrations-reconnect-lib": "static-1.341",
  "ui-addon-iframeable": "static-1.9286",
  "ui-addon-integrations-directory-panel": "static-2.8234",
  "ui-product-approvals": "static-1.28923",
  "ui-tool-access": "static-1.10364",
  "inbound-db-properties-service-client": "static-1.3993",
  "property-management-common": "static-1.6149",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.556",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.989",
  "quartz-test": "static-1.989",
  "quartz-tracking": "static-1.693",
  "trellis-components": "static-1.2384",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.282",
  "bender-build-tools": "static-1.3336",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22402",
  "ContentUtils": "static-1.68973",
  "customer-data-objects-ui-components": "static-1.13242",
  "sassPrefix": "static-1.160",
  "avatar-components": "static-1.2707",
  "breeze-engine-core": "static-1.746",
  "breeze-onboarding-components": "static-1.537",
  "customer-data-filters-ui": "static-1.40605",
  "customer-data-reference-ui-components": "static-1.13390",
  "embedded-academy-lib": "static-1.15185",
  "ExportDialog": "static-6.10589",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41837",
  "reporting-snowflake": "static-1.57045",
  "reporting-ui-components": "static-2.65698",
  "reporting-visualizations": "static-1.60503",
  "trellis-theming": "static-1.1167",
  "ui-addon-teams": "static-1.21816",
  "upgrade-components-lib": "static-1.414",
  "magpie-lib": "static-1.5700",
  "navigation-components": "static-1.18634",
  "breeze-engine-lib": "static-1.1468",
  "magpie-types": "static-1.5160",
  "simple-logging-lib": "static-1.3259",
  "fail-safe": "static-1.158",
  "app-governance-lib": "static-1.2202",
  "developer-experience-shared-components": "static-1.10710",
  "purchase-motions-components": "static-1.6236",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.9864",
  "usage-tracker-anonymous": "static-1.5983",
  "usage-tracker-public": "static-1.7377",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3913",
  "reference-resolvers": "static-1.8390",
  "ui-extensibility-client-types": "static-1.4131",
  "hubspot-apollo-cache": "static-1.548",
  "universal-page-editor-lib": "static-1.3221",
  "final-form": "static-1.73",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3367",
  "atom": "static-1.5288",
  "merchandise-lib": "static-1.270",
  "salesImages": "static-1.529",
  "codemirror": "static-5.98",
  "react-codemirror": "static-1.10852",
  "ui-addon-draggable": "static-3.4967",
  "content-assistance-lib": "static-1.8081",
  "content-media-capture": "static-1.5190",
  "customer-data-ui-utilities": "static-1.10036",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24264",
  "growth-payments-core": "static-1.25993",
  "knowledge-content-types": "static-1.8603",
  "payment-link-components": "static-1.24005",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20185",
  "ui-addon-emoji-picker": "static-1.10098",
  "ui-business-units-lib": "static-1.9292",
  "video-components-external": "static-1.11953",
  "video-data-lib": "static-1.35611",
  "navigation-messaging": "static-1.7961",
  "collaboration-sidebar": "static-1.58522",
  "react-dnd-compat": "static-1.4827",
  "batch-promise": "static-1.1756",
  "crm-component-utils": "static-1.39655",
  "crm-properties-common-lib": "static-1.6100",
  "customer-data-properties": "static-1.52320",
  "external-options-client-types": "static-1.4273",
  "framework-data-schema-resolvers": "static-1.7106",
  "property-value-citations": "static-1.2934",
  "reference-resolvers-lite": "static-1.8308",
  "hubspotter-http-shared-msw-handlers": "static-1.10464",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.35",
  "cms-field-types": "static-1.5027",
  "content-icons-ui": "static-1.2291",
  "breeze-artifacts-sdk": "static-1.60",
  "onboarding-journeys-lib": "static-1.667",
  "conversations-skeleton-state": "static-1.7460",
  "crm-message-bus": "static-1.43564",
  "customer-data-filters-ui-msw-helpers": "static-1.23040",
  "events-data-lib": "static-1.450",
  "FormUrlGenerator": "static-2.4936",
  "framework-builder-read-service-client": "static-1.4154",
  "framework-data-schema-quick-fetch": "static-1.7011",
  "multi-account-reference-resolvers": "static-1.1195",
  "onboarding-tours": "static-1.16986",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14292",
  "academy-common-lib": "static-1.14645",
  "pulse": "static-1.829",
  "dashboard-lib": "static-1.82394",
  "getting-started-shared-tasks": "static-1.19025",
  "hubspot-prosemirror-plugins": "static-1.18824",
  "share-with-third-party-component-lib": "static-1.8914",
  "ui-asset-management-lib": "static-1.11300",
  "user-context": "static-1.5324",
  "reporting-plugins": "static-1.10658",
  "reporting-reports": "static-1.68105",
  "idb-keyval": "static-1.47",
  "reactive-lib": "static-1.934",
  "nest": "static-1.450",
  "breeze-engine-chat-components": "static-1.446",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.109",
  "framework-listing-lib": "static-2.29293",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31206",
  "apps-service-types": "static-1.3976",
  "oauth-service-types": "static-1.4465",
  "onboarding-scopes": "static-1.6668",
  "purchase-motions-api": "static-1.6239",
  "signup-constants": "static-1.19410",
  "signup-ui-url-generator": "static-2.8269",
  "onboarding-tours-client": "static-1.5200",
  "platform-infra-nav-components": "static-1.7816",
  "subscription-experience-data-types": "static-1.15162",
  "crm-record-cards-service-types": "static-1.3731",
  "location-customization-utils-lib": "static-1.9904",
  "redux-thunk": "static-2.43",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.74",
  "ui-coaching-tips": "static-1.29142",
  "content-media-composition-data-lib": "static-1.12994",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4637",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.500",
  "ui-addon-opt": "static-4.8573",
  "commerce-tours-lib": "static-1.6482",
  "growth-onboarding-reliability": "static-1.5294",
  "sales-checkout-service-client": "static-1.3746",
  "data-token-picker": "static-1.16766",
  "FileManagerLib": "static-1.39904",
  "content-media-compositions": "static-2.17001",
  "media-bridge-lib": "static-1.19283",
  "chatspot-widget-iframe": "static-1.22393",
  "collaboration-sidebar-common": "static-1.3319",
  "marketing-platform-lib": "static-1.7080",
  "card-properties-lib": "static-1.44823",
  "commerce-subscription-lib": "static-1.37614",
  "crm-actions": "static-1.6563",
  "crm-cards-sdk": "static-1.44271",
  "customer-data-properties-shared-msw-handlers": "static-1.9793",
  "customer-data-tracking": "static-1.7096",
  "hs-resources": "static-1.394",
  "calling-global-api": "static-1.65224",
  "calling-internal-common": "static-1.31526",
  "calling-lifecycle-internal": "static-1.66606",
  "calling-lifecycle-messages": "static-1.58900",
  "commerce-products-lib": "static-1.10311",
  "conditional-properties-service-client": "static-1.3944",
  "crm-links": "static-1.6531",
  "crm-index-visualization-core": "static-1.4415",
  "crm-pipelines-api-client-types": "static-1.4283",
  "formula-editor": "static-1.14621",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4363",
  "meetings-icalendar-utils-lib": "static-1.842",
  "multi-currency-client-types": "static-1.3838",
  "object-builder-ui-client": "static-1.49426",
  "pipeline-validation-client-types": "static-1.4113",
  "smart-property-lib": "static-1.8111",
  "tiered-pricing": "static-1.1800",
  "topics-actions-lib": "static-1.368",
  "ui-addon-form-validation": "static-1.11199",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.225",
  "restore-request-side-panel-lib": "static-1.1434",
  "growth-data-modal": "static-1.5765",
  "growth-onboarding-confetti": "static-1.3272",
  "growth-onboarding-next-action-utils": "static-1.2520",
  "onboarding-tours-utils": "static-1.1052",
  "ui-shepherd-tracker": "static-1.7854",
  "academy-service-client": "static-1.3899",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39763",
  "SafeStorage": "static-1.4615",
  "video-embed": "static-1.36445",
  "bend-plugin-pulse": "static-1.332",
  "event-emitter": "static-1.1162",
  "fast-json-patch": "static-1.66",
  "redux-actions": "static-3.7",
  "EmailSignatureEditor": "static-1.24854",
  "viral-links-lib": "static-1.7282",
  "nested-table": "static-1.448",
  "timezone-utils": "static-2.5457",
  "getting-started-shared-tasks-store": "static-1.18143",
  "campaign-roi-lib": "static-1.9885",
  "ui-addon-calendars": "static-2.5537",
  "customer-data-views-management": "static-1.25874",
  "framework-data-table": "static-2.12380",
  "nudge-client-utils": "static-1.3015",
  "nudge-custom-ui-functions": "static-1.1368",
  "switchboard-lib": "static-1.431",
  "app-users-service-client": "static-1.5831",
  "app-users-service-types": "static-1.5239",
  "mini-checkout-client": "static-1.27361",
  "onboarding-utils": "static-1.5576",
  "permissions-shared-i18n-strings-fe": "static-1.2101",
  "ui-coaching-tips-shared-config": "static-1.29127",
  "edison-service-client-types": "static-1.598",
  "growth-onboarding-feedback-components": "static-1.6793",
  "audio-components": "static-1.6223",
  "FileManagerImages": "static-1.37415",
  "video-components": "static-1.13955",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92645",
  "customer-data-sidebar": "static-2.46577",
  "enrichment-properties-lib": "static-1.17605",
  "ui-addon-draggable-compat": "static-2.4471",
  "universal-record-utils-lib": "static-1.1591",
  "commerce-billing-lib": "static-1.19825",
  "commerce-shared-components-lib": "static-1.19061",
  "commerce-tools-ui-lib": "static-1.10896",
  "crm-fe-perf": "static-1.23113",
  "calling-error-reporting": "static-1.31533",
  "shared-worker-versioning": "static-1.11250",
  "calling-usage-tracker": "static-1.6753",
  "voice-sms-access-library": "static-1.1750",
  "commerce-permissions": "static-1.988",
  "products-iframe-lib": "static-1.8429",
  "products-ui-components-shared-msw-handlers": "static-1.10848",
  "crm-index-associations-lib": "static-1.6653",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10549",
  "sales-views-client-types": "static-1.4468",
  "bark-lib": "static-1.16713",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.519",
  "policy-lib": "static-1.7002",
  "react-tinymce": "static-1.55800",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10612",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54926",
  "tinymce-plugins": "static-1.58040",
  "tinymce-themes": "static-1.56896",
  "onboarding-data-sync-lib": "static-1.2332",
  "growth-onboarding-next-action-components": "static-1.2548",
  "user-context-client": "static-1.4754",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4745",
  "outpost": "static-1.4376",
  "draft-convert": "static-2.76",
  "draft-extend": "static-3.79",
  "draft-js": "static-5.81",
  "draft-plugins": "static-2.22030",
  "sales-email-signature-service-client": "static-1.4055",
  "ts-utils-lib": "static-1.386",
  "crm-export-dialog": "static-1.6494",
  "crm-view-components": "static-1.909",
  "react-beautiful-dnd": "static-1.66",
  "customer-data-associations": "static-1.7544",
  "nudge-custom-function-registry": "static-1.2772",
  "nudge-renderer-utils": "static-1.3091",
  "whisper-core-api": "static-1.7144",
  "InboxConnectUtils": "static-4.15380",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.6072",
  "settings-content-modals": "static-1.46672",
  "social-insights-client-types": "static-1.22616",
  "crm_universal": "static-1.22372",
  "customer-data-email": "static-1.18401",
  "card-payment-highlight-lib": "static-1.37791",
  "card-subscription-highlight-lib": "static-1.40037",
  "commerce-contract-lib": "static-1.13026",
  "invoices-highlight-card-lib": "static-1.55416",
  "orders-highlight-card-lib": "static-1.22013",
  "products-highlight-card-lib": "static-1.18594",
  "quotes-highlight-card-lib": "static-1.72664",
  "crm-source-interpretation-lib": "static-1.5546",
  "crm-object-search-query-utilities": "static-1.10038",
  "utility-belt": "static-1.2743",
  "payments-enrollment-embed-lib": "static-1.23627",
  "stripe-embedded-components": "static-1.7872",
  "customer-data-rte": "static-1.33500",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6141",
  "payments-post-enroll-local-storage-lib": "static-1.5317",
  "qrcode-generator": "static-1.72",
  "quotes-client-types": "static-1.38754",
  "calling-orchestration-schema": "static-1.36527",
  "react-reducer-toolkit": "static-1.16191",
  "hub-http-contrib": "static-1.3253",
  "interframe": "static-3.4967",
  "tinymce-data": "static-1.41011",
  "ui-addon-sales-email": "static-1.5424",
  "layout-dnd-components": "static-1.12837",
  "layout-dnd-utils": "static-1.11812",
  "ui-brand-identity-lib": "static-1.16074",
  "NamespacedHubStyle": "static-2.9197",
  "meetings-connect-utils-lib": "static-1.7819",
  "checkout-sdk": "static-3.24204",
  "company-details-components": "static-1.6411",
  "payment-method-components": "static-1.7060",
  "pricing-pages-ui-components": "static-1.15212",
  "quote-checkout-service-types": "static-1.3665",
  "upgrade-catalog-service-types": "static-1.3702",
  "access-control-lib": "static-1.10650",
  "EmailComponents": "static-1.55378",
  "EmailData": "static-1.54056",
  "redux-less": "static-2.9693",
  "sequences-lib": "static-1.8399",
  "ui-gdpr-components": "static-1.10562",
  "products-ui-components": "static-1.40829",
  "accounting-integrations-ui-components": "static-1.7411",
  "invoices-ui-lib": "static-1.55432",
  "commerce-products-api": "static-1.2597",
  "invoices-iframe-lib": "static-1.57490",
  "quotes-modal-lib": "static-1.103342",
  "quotes-ui-lib": "static-1.81385",
  "stripe-connect-js": "static-1.73",
  "draft-content-plugins": "static-1.28767",
  "ContentData": "static-1.69048",
  "layout-data-lib": "static-1.10137",
  "hub-http-rxjs": "static-1.824",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4148",
  "billing-payments-client-types": "static-1.4202",
  "react-performance-metrics-lib": "static-1.766",
  "pricing-pages-api": "static-1.15077",
  "ContentComponents": "static-2.71929",
  "marketing-contacts-lib": "static-1.10780",
  "marketing-email-service-types": "static-1.2048",
  "messaging-editing-lib": "static-1.46952",
  "messaging-usage-based-billing-components-lib": "static-1.1814",
  "automation-ui-source-apps": "static-1.19488",
  "automation-ui-types": "static-1.20406",
  "messaging-types-lib": "static-1.46689",
  "onboarding-settings-client": "static-1.4720",
  "sequences-client-types-lib": "static-1.8256",
  "commerce-tax-lib": "static-1.750",
  "price-books-api": "static-1.1537",
  "price-books-components": "static-1.1595",
  "property-description-translator": "static-1.4051",
  "ramp-editor": "static-1.734",
  "commerce-analytics-service-client": "static-1.3734",
  "totals-ui-components": "static-1.24141",
  "SalesContentIndexUI": "static-3.9522",
  "advanced-menus-core": "static-1.15461",
  "advanced-menus-lib": "static-1.12352",
  "ui-memberships-settings-lib": "static-1.34637",
  "segments-query-core": "static-1.1633",
  "automation-ui-ubb": "static-1.6322",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7547",
  "data-token-views": "static-1.16747",
  "forms-utils-lib": "static-1.12960",
  "payments-embed-points-lib": "static-1.13454",
  "simple-menus-core": "static-1.15460",
  "simple-menus-lib": "static-1.16977",
  "videoconference-integration-components": "static-1.7125",
  "marketing-contacts-client": "static-1.7721",
  "mc-hard-limits-client-types": "static-1.113",
  "automation-applications-service-types": "static-1.3630",
  "automation-platform-service-types": "static-1.2641",
  "ContentEditorUI": "static-2.77711",
  "short-messages-app-service-client": "static-1.4130",
  "web-interactives-components": "static-1.14120",
  "web-interactives-data": "static-1.14121",
  "messaging-shared-utils-lib": "static-1.1263",
  "messaging-user-info-utils-lib": "static-1.1433",
  "email-portal-health-service-types": "static-1.1189",
  "line-items-api": "static-1.996",
  "commerce-totals-service-types": "static-1.3963",
  "FireAlarmUi": "static-1.4655",
  "sales-templates-service-types-lib": "static-1.4315",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22342",
  "automation-ui-usage-tracking": "static-1.21805",
  "data-studio-ubb": "static-1.3336",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27501",
  "content-management-data-lib": "static-1.5816",
  "copilot-plugins": "static-1.11647",
  "cta-picker": "static-1.36928",
  "customer-agent-discovery-components-lib": "static-1.3701",
  "editor-components": "static-1.13529",
  "editor-iframe-lib": "static-1.8686",
  "error-messaging-js": "static-1.5407",
  "FormsCommonComponents": "static-1.86409",
  "pictos": "static-7.188",
  "react-transition-group": "static-2.68",
  "redux-request-state": "static-1.10859",
  "SharedLegalStrings": "static-1.1957",
  "smart-content-core": "static-1.43008",
  "smart-content-lib": "static-1.43661",
  "social-composer-lib": "static-1.59955",
  "structured-content-lib": "static-1.25751",
  "theme-previewer-lib": "static-1.53779",
  "tinymce-copilot": "static-1.16994",
  "xray-recommendation-lib": "static-1.8167",
  "automation-ui-routing": "static-1.21763",
  "sql-reporting-client-types": "static-1.5818",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42645",
  "campaigns-utils-lib": "static-1.3407",
  "reporting-enablement": "static-1.23624",
  "forms-ai-lib": "static-1.4636",
  "codemirror-dlb": "static-1.59270",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6648",
  "report-customization-components": "static-1.13716",
  "data-quality-ui-library": "static-1.13596",
  "reporting-filters": "static-1.843",
  "reporting-insights-lib": "static-1.2373"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13023",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.489",
  "data-fetching-client": "/data-fetching-client/static-1.9869",
  "foundations-components": "/foundations-components/static-1.8325",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1350",
  "foundations-theming": "/foundations-theming/static-1.4659",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.85",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8237",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10466",
  "hubspot-dlb": "/hubspot-dlb/static-2.1877",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4282",
  "HubStyleTokens": "/HubStyleTokens/static-2.11686",
  "I18n": "/I18n/static-7.1651",
  "jasmine-runner": "/jasmine-runner/static-1.6665",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.481",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13086",
  "quartz": "/quartz/static-1.7314",
  "react-dlb": "/react-dlb/static-1.84",
  "react-rhumb": "/react-rhumb/static-1.16915",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3067",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10360",
  "reselect": "/reselect/static-3.8",
  "settings-ui-lib": "/settings-ui-lib/static-1.12731",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7504",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11357",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9746",
  "unified-auth": "/unified-auth/static-1.746",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1028",
  "usage-tracker": "/usage-tracker/static-1.7566",
  "usage-tracker-core": "/usage-tracker-core/static-1.7416",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8307",
  "hub-http": "/hub-http/static-1.6429",
  "integrations-lib": "/integrations-lib/static-1.16817",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20459",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.445",
  "property-management-iframe": "/property-management-iframe/static-1.13861",
  "quartz-config": "/quartz-config/static-1.1092",
  "quartz-core": "/quartz-core/static-1.6533",
  "quartz-routing": "/quartz-routing/static-1.744",
  "quick-fetch": "/quick-fetch/static-1.4064",
  "react": "/react/static-7.190",
  "rpc-client-utils": "/rpc-client-utils/static-1.4872",
  "ts-schema": "/ts-schema/static-1.4227",
  "ui-universal-auth": "/ui-universal-auth/static-1.9232",
  "UIComponents": "/UIComponents/static-3.8632",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9849",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.94",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3547",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3591",
  "quartz-webpack": "/quartz-webpack/static-1.3538",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.392",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4594",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-assets": "/foundations-assets/static-1.5086",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2375",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-story-utils": "/hs-story-utils/static-1.9637",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.51",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5487",
  "react-virtualized": "/react-virtualized/static-2.102",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2365",
  "ui-fonts": "/ui-fonts/static-1.948",
  "ui-images": "/ui-images/static-2.1215",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3142",
  "foundations-theming-base": "/foundations-theming-base/static-1.3644",
  "stylex": "/stylex/static-1.37",
  "HeadJS": "/HeadJS/static-2.782",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3348",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4534",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8918",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9501",
  "ai-rendering-library": "/ai-rendering-library/static-1.10925",
  "chirp-fetch": "/chirp-fetch/static-1.2099",
  "connections-embed-lib": "/connections-embed-lib/static-1.1368",
  "copilot-toolkit": "/copilot-toolkit/static-1.11675",
  "feedback-loader": "/feedback-loader/static-1.29679",
  "laboratory-lib": "/laboratory-lib/static-3.7363",
  "marketplace-embed": "/marketplace-embed/static-1.22730",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10354",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20414",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14629",
  "sanitize-text": "/sanitize-text/static-1.8360",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5980",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5252",
  "wootric-nps": "/wootric-nps/static-1.7130",
  "quartz-head": "/quartz-head/static-1.979",
  "web-vitals": "/web-vitals/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4868",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4361",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2635",
  "reporting-data": "/reporting-data/static-1.68427",
  "cssUtils": "/cssUtils/static-1.855",
  "flux-actions": "/flux-actions/static-1.355",
  "HubStyle": "/HubStyle/static-2.11993",
  "PatternValidationJS": "/PatternValidationJS/static-1.3109",
  "react-colorpicker": "/react-colorpicker/static-2.10421",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10578",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7556",
  "icons": "/icons/static-2.668",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18991",
  "storybook-react": "/storybook-react/static-1.36",
  "trellis-story-utils": "/trellis-story-utils/static-1.4719",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5808",
  "quartz-i18n": "/quartz-i18n/static-1.989",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.277",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.812",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.853",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.976",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.296",
  "slack-ui-library": "/slack-ui-library/static-1.10611",
  "fsm": "/fsm/static-1.3945",
  "customer-data-objects": "/customer-data-objects/static-1.7893",
  "property-translator": "/property-translator/static-1.5607",
  "hs-locale-management": "/hs-locale-management/static-1.227",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8139",
  "hs-promise-utils": "/hs-promise-utils/static-1.5805",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5089",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14232",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5819",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7988",
  "sanitize": "/sanitize/static-1.4689",
  "superstore": "/superstore/static-1.4968",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10473",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8203",
  "hub-http-janus": "/hub-http-janus/static-1.859",
  "hubspotter-http": "/hubspotter-http/static-1.4798",
  "immutable-less": "/immutable-less/static-1.4863",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17866",
  "nav-meta": "/nav-meta/static-1.30271",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18272",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.818",
  "ai-studio-lib": "/ai-studio-lib/static-1.12260",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18832",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.341",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9286",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8234",
  "ui-product-approvals": "/ui-product-approvals/static-1.28923",
  "ui-tool-access": "/ui-tool-access/static-1.10364",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3993",
  "property-management-common": "/property-management-common/static-1.6149",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.556",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.989",
  "quartz-test": "/quartz-test/static-1.989",
  "quartz-tracking": "/quartz-tracking/static-1.693",
  "trellis-components": "/trellis-components/static-1.2384",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.282",
  "bender-build-tools": "/bender-build-tools/static-1.3336",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22402",
  "ContentUtils": "/ContentUtils/static-1.68973",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13242",
  "sassPrefix": "/sassPrefix/static-1.160",
  "avatar-components": "/avatar-components/static-1.2707",
  "breeze-engine-core": "/breeze-engine-core/static-1.746",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.537",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40605",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13390",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15185",
  "ExportDialog": "/ExportDialog/static-6.10589",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41837",
  "reporting-snowflake": "/reporting-snowflake/static-1.57045",
  "reporting-ui-components": "/reporting-ui-components/static-2.65698",
  "reporting-visualizations": "/reporting-visualizations/static-1.60503",
  "trellis-theming": "/trellis-theming/static-1.1167",
  "ui-addon-teams": "/ui-addon-teams/static-1.21816",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.414",
  "magpie-lib": "/magpie-lib/static-1.5700",
  "navigation-components": "/navigation-components/static-1.18634",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1468",
  "magpie-types": "/magpie-types/static-1.5160",
  "simple-logging-lib": "/simple-logging-lib/static-1.3259",
  "fail-safe": "/fail-safe/static-1.158",
  "app-governance-lib": "/app-governance-lib/static-1.2202",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10710",
  "purchase-motions-components": "/purchase-motions-components/static-1.6236",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9864",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5983",
  "usage-tracker-public": "/usage-tracker-public/static-1.7377",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3913",
  "reference-resolvers": "/reference-resolvers/static-1.8390",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4131",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.548",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3221",
  "final-form": "/final-form/static-1.73",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3367",
  "atom": "/atom/static-1.5288",
  "merchandise-lib": "/merchandise-lib/static-1.270",
  "salesImages": "/salesImages/static-1.529",
  "codemirror": "/codemirror/static-5.98",
  "react-codemirror": "/react-codemirror/static-1.10852",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4967",
  "content-assistance-lib": "/content-assistance-lib/static-1.8081",
  "content-media-capture": "/content-media-capture/static-1.5190",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10036",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24264",
  "growth-payments-core": "/growth-payments-core/static-1.25993",
  "knowledge-content-types": "/knowledge-content-types/static-1.8603",
  "payment-link-components": "/payment-link-components/static-1.24005",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20185",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10098",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9292",
  "video-components-external": "/video-components-external/static-1.11953",
  "video-data-lib": "/video-data-lib/static-1.35611",
  "navigation-messaging": "/navigation-messaging/static-1.7961",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58522",
  "react-dnd-compat": "/react-dnd-compat/static-1.4827",
  "batch-promise": "/batch-promise/static-1.1756",
  "crm-component-utils": "/crm-component-utils/static-1.39655",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6100",
  "customer-data-properties": "/customer-data-properties/static-1.52320",
  "external-options-client-types": "/external-options-client-types/static-1.4273",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7106",
  "property-value-citations": "/property-value-citations/static-1.2934",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8308",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10464",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "cms-field-types": "/cms-field-types/static-1.5027",
  "content-icons-ui": "/content-icons-ui/static-1.2291",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.60",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.667",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7460",
  "crm-message-bus": "/crm-message-bus/static-1.43564",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23040",
  "events-data-lib": "/events-data-lib/static-1.450",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4936",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4154",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7011",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1195",
  "onboarding-tours": "/onboarding-tours/static-1.16986",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14292",
  "academy-common-lib": "/academy-common-lib/static-1.14645",
  "pulse": "/pulse/static-1.829",
  "dashboard-lib": "/dashboard-lib/static-1.82394",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19025",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18824",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8914",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11300",
  "user-context": "/user-context/static-1.5324",
  "reporting-plugins": "/reporting-plugins/static-1.10658",
  "reporting-reports": "/reporting-reports/static-1.68105",
  "idb-keyval": "/idb-keyval/static-1.47",
  "reactive-lib": "/reactive-lib/static-1.934",
  "nest": "/nest/static-1.450",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.446",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.109",
  "framework-listing-lib": "/framework-listing-lib/static-2.29293",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31206",
  "apps-service-types": "/apps-service-types/static-1.3976",
  "oauth-service-types": "/oauth-service-types/static-1.4465",
  "onboarding-scopes": "/onboarding-scopes/static-1.6668",
  "purchase-motions-api": "/purchase-motions-api/static-1.6239",
  "signup-constants": "/signup-constants/static-1.19410",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8269",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5200",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7816",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15162",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3731",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9904",
  "redux-thunk": "/redux-thunk/static-2.43",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29142",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12994",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4637",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.500",
  "ui-addon-opt": "/ui-addon-opt/static-4.8573",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6482",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5294",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3746",
  "data-token-picker": "/data-token-picker/static-1.16766",
  "FileManagerLib": "/FileManagerLib/static-1.39904",
  "content-media-compositions": "/content-media-compositions/static-2.17001",
  "media-bridge-lib": "/media-bridge-lib/static-1.19283",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22393",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3319",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7080",
  "card-properties-lib": "/card-properties-lib/static-1.44823",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37614",
  "crm-actions": "/crm-actions/static-1.6563",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44271",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9793",
  "customer-data-tracking": "/customer-data-tracking/static-1.7096",
  "hs-resources": "/hs-resources/static-1.394",
  "calling-global-api": "/calling-global-api/static-1.65224",
  "calling-internal-common": "/calling-internal-common/static-1.31526",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66606",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58900",
  "commerce-products-lib": "/commerce-products-lib/static-1.10311",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3944",
  "crm-links": "/crm-links/static-1.6531",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4415",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4283",
  "formula-editor": "/formula-editor/static-1.14621",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4363",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.842",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3838",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49426",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4113",
  "smart-property-lib": "/smart-property-lib/static-1.8111",
  "tiered-pricing": "/tiered-pricing/static-1.1800",
  "topics-actions-lib": "/topics-actions-lib/static-1.368",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11199",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.225",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1434",
  "growth-data-modal": "/growth-data-modal/static-1.5765",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3272",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2520",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1052",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7854",
  "academy-service-client": "/academy-service-client/static-1.3899",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39763",
  "SafeStorage": "/SafeStorage/static-1.4615",
  "video-embed": "/video-embed/static-1.36445",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.332",
  "event-emitter": "/event-emitter/static-1.1162",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "redux-actions": "/redux-actions/static-3.7",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24854",
  "viral-links-lib": "/viral-links-lib/static-1.7282",
  "nested-table": "/nested-table/static-1.448",
  "timezone-utils": "/timezone-utils/static-2.5457",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18143",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9885",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5537",
  "customer-data-views-management": "/customer-data-views-management/static-1.25874",
  "framework-data-table": "/framework-data-table/static-2.12380",
  "nudge-client-utils": "/nudge-client-utils/static-1.3015",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1368",
  "switchboard-lib": "/switchboard-lib/static-1.431",
  "app-users-service-client": "/app-users-service-client/static-1.5831",
  "app-users-service-types": "/app-users-service-types/static-1.5239",
  "mini-checkout-client": "/mini-checkout-client/static-1.27361",
  "onboarding-utils": "/onboarding-utils/static-1.5576",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2101",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29127",
  "edison-service-client-types": "/edison-service-client-types/static-1.598",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6793",
  "audio-components": "/audio-components/static-1.6223",
  "FileManagerImages": "/FileManagerImages/static-1.37415",
  "video-components": "/video-components/static-1.13955",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92645",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46577",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17605",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4471",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1591",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19825",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19061",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10896",
  "crm-fe-perf": "/crm-fe-perf/static-1.23113",
  "calling-error-reporting": "/calling-error-reporting/static-1.31533",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11250",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6753",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1750",
  "commerce-permissions": "/commerce-permissions/static-1.988",
  "products-iframe-lib": "/products-iframe-lib/static-1.8429",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10848",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6653",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10549",
  "sales-views-client-types": "/sales-views-client-types/static-1.4468",
  "bark-lib": "/bark-lib/static-1.16713",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.519",
  "policy-lib": "/policy-lib/static-1.7002",
  "react-tinymce": "/react-tinymce/static-1.55800",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10612",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54926",
  "tinymce-plugins": "/tinymce-plugins/static-1.58040",
  "tinymce-themes": "/tinymce-themes/static-1.56896",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2332",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2548",
  "user-context-client": "/user-context-client/static-1.4754",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4745",
  "outpost": "/outpost/static-1.4376",
  "draft-convert": "/draft-convert/static-2.76",
  "draft-extend": "/draft-extend/static-3.79",
  "draft-js": "/draft-js/static-5.81",
  "draft-plugins": "/draft-plugins/static-2.22030",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4055",
  "ts-utils-lib": "/ts-utils-lib/static-1.386",
  "crm-export-dialog": "/crm-export-dialog/static-1.6494",
  "crm-view-components": "/crm-view-components/static-1.909",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.66",
  "customer-data-associations": "/customer-data-associations/static-1.7544",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2772",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3091",
  "whisper-core-api": "/whisper-core-api/static-1.7144",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15380",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.6072",
  "settings-content-modals": "/settings-content-modals/static-1.46672",
  "social-insights-client-types": "/social-insights-client-types/static-1.22616",
  "crm_universal": "/crm_universal/static-1.22372",
  "customer-data-email": "/customer-data-email/static-1.18401",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37791",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40037",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13026",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55416",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22013",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18594",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72664",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5546",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10038",
  "utility-belt": "/utility-belt/static-1.2743",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23627",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7872",
  "customer-data-rte": "/customer-data-rte/static-1.33500",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6141",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5317",
  "qrcode-generator": "/qrcode-generator/static-1.72",
  "quotes-client-types": "/quotes-client-types/static-1.38754",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36527",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16191",
  "hub-http-contrib": "/hub-http-contrib/static-1.3253",
  "interframe": "/interframe/static-3.4967",
  "tinymce-data": "/tinymce-data/static-1.41011",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5424",
  "layout-dnd-components": "/layout-dnd-components/static-1.12837",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11812",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16074",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9197",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7819",
  "checkout-sdk": "/checkout-sdk/static-3.24204",
  "company-details-components": "/company-details-components/static-1.6411",
  "payment-method-components": "/payment-method-components/static-1.7060",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15212",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3665",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3702",
  "access-control-lib": "/access-control-lib/static-1.10650",
  "EmailComponents": "/EmailComponents/static-1.55378",
  "EmailData": "/EmailData/static-1.54056",
  "redux-less": "/redux-less/static-2.9693",
  "sequences-lib": "/sequences-lib/static-1.8399",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10562",
  "products-ui-components": "/products-ui-components/static-1.40829",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7411",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55432",
  "commerce-products-api": "/commerce-products-api/static-1.2597",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57490",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103342",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81385",
  "stripe-connect-js": "/stripe-connect-js/static-1.73",
  "draft-content-plugins": "/draft-content-plugins/static-1.28767",
  "ContentData": "/ContentData/static-1.69048",
  "layout-data-lib": "/layout-data-lib/static-1.10137",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.824",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4148",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4202",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.766",
  "pricing-pages-api": "/pricing-pages-api/static-1.15077",
  "ContentComponents": "/ContentComponents/static-2.71929",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10780",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2048",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46952",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1814",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19488",
  "automation-ui-types": "/automation-ui-types/static-1.20406",
  "messaging-types-lib": "/messaging-types-lib/static-1.46689",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4720",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8256",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.750",
  "price-books-api": "/price-books-api/static-1.1537",
  "price-books-components": "/price-books-components/static-1.1595",
  "property-description-translator": "/property-description-translator/static-1.4051",
  "ramp-editor": "/ramp-editor/static-1.734",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3734",
  "totals-ui-components": "/totals-ui-components/static-1.24141",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9522",
  "advanced-menus-core": "/advanced-menus-core/static-1.15461",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12352",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34637",
  "segments-query-core": "/segments-query-core/static-1.1633",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6322",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7547",
  "data-token-views": "/data-token-views/static-1.16747",
  "forms-utils-lib": "/forms-utils-lib/static-1.12960",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13454",
  "simple-menus-core": "/simple-menus-core/static-1.15460",
  "simple-menus-lib": "/simple-menus-lib/static-1.16977",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7125",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7721",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.113",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3630",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2641",
  "ContentEditorUI": "/ContentEditorUI/static-2.77711",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4130",
  "web-interactives-components": "/web-interactives-components/static-1.14120",
  "web-interactives-data": "/web-interactives-data/static-1.14121",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1263",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1433",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1189",
  "line-items-api": "/line-items-api/static-1.996",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3963",
  "FireAlarmUi": "/FireAlarmUi/static-1.4655",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4315",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22342",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21805",
  "data-studio-ubb": "/data-studio-ubb/static-1.3336",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27501",
  "content-management-data-lib": "/content-management-data-lib/static-1.5816",
  "copilot-plugins": "/copilot-plugins/static-1.11647",
  "cta-picker": "/cta-picker/static-1.36928",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3701",
  "editor-components": "/editor-components/static-1.13529",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8686",
  "error-messaging-js": "/error-messaging-js/static-1.5407",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86409",
  "pictos": "/pictos/static-7.188",
  "react-transition-group": "/react-transition-group/static-2.68",
  "redux-request-state": "/redux-request-state/static-1.10859",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1957",
  "smart-content-core": "/smart-content-core/static-1.43008",
  "smart-content-lib": "/smart-content-lib/static-1.43661",
  "social-composer-lib": "/social-composer-lib/static-1.59955",
  "structured-content-lib": "/structured-content-lib/static-1.25751",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53779",
  "tinymce-copilot": "/tinymce-copilot/static-1.16994",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8167",
  "automation-ui-routing": "/automation-ui-routing/static-1.21763",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5818",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42645",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3407",
  "reporting-enablement": "/reporting-enablement/static-1.23624",
  "forms-ai-lib": "/forms-ai-lib/static-1.4636",
  "codemirror-dlb": "/codemirror-dlb/static-1.59270",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6648",
  "report-customization-components": "/report-customization-components/static-1.13716",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13596",
  "reporting-filters": "/reporting-filters/static-1.843",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2373"
}
};
